<ng-container>
  <div class="loader absolute" *ngIf="isLoading || isPDFDownloadLoading">
    <svg class="circular" viewBox="25 25 50 50">
      <circle class="path" cx="50" cy="50" r="20" fill="none" stroke-width="4" stroke-miterlimit="10"></circle>
    </svg>
  </div>
  <div class="filters-area"> 
    <div class="filter">
      <!-- site filter-->
      <div class="btn-area">
        <div class="button button-white dense-icon-btn">
          <div class="btn-inner dense-icon-btn filter-btn">
            <div *ngIf="!selectedSite" (click)="isUnfoldSiteListDropdown = true">
              <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Site Filter</span>
            </div>
            <ng-container *ngIf="selectedSite"><i class="material-icons filter-icon">person</i><span class="exist-filter ellipsis" *ngIf="selectedSite" style="max-width: 200px;" (click)="isUnfoldSiteListDropdown = true">{{selectedSite.name}}</span><i class="material-icons filter-icon" style="margin-left: 8px;" (click)="clearSiteFilter()">cancel</i></ng-container>
          </div>
        </div>
        <div class="filter-box" *ngIf="isUnfoldSiteListDropdown">
          <div class="select-list" #siteSelect>
            <div class="search-result-input">
              <input class="list-search-input" autocomplete="off" type="text" #selectSearchInput placeholder="Search Site" [(ngModel)]="searchSiteTxt" (input)="searchSite(searchSiteTxt)"/>
            </div>
            <div style="max-height: 200px;overflow-y: auto; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
              <div class="select-result has-child selectitem" *ngFor="let site of filteredSiteList" (click)="$event.stopPropagation();selectSite(site)">
                <div class="ellipsis" [class.selected]="site?.site_id == selectedSite?.site_id">{{site.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- Visibility filter-->
      <div class="btn-area">
        <div class="button button-white dense-icon-btn">
          <div class="btn-inner dense-icon-btn filter-btn">
            <div *ngIf="selectedVisibilityListLabels == 'All'" (click)="isUnfoldVisibilityListDropdown = true">
              <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Visibility</span>
            </div>
            <ng-container *ngIf="selectedVisibilityListLabels != 'All'"><i class="material-icons filter-icon">expand_circle_down</i><span class="exist-filter ellipsis" *ngIf="selectedVisibilityList?.length" style="max-width: 200px;" (click)="isUnfoldVisibilityListDropdown = true">{{ selectedVisibilityListLabels }}</span><i class="material-icons filter-icon" style="margin-left: 8px" (click)="clearVisibilityFilter()">cancel</i></ng-container>
          </div>
        </div>
        <div class="filter-box" *ngIf="isUnfoldVisibilityListDropdown" style="width: 180px">
          <div class="select-list" #visibilitySelect>
            <div style="border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
              <div class="select-result selectitem">
                <div style="color:hsla(0,0%,0%,0.87)">Visibility</div>
              </div>
              <div class="select-result has-child selectitem" *ngFor="let visibility of visibilityList" (click)="selectVisibility($event, visibility)">
                <div class="check-area"><i class="material-icons check-icon" *ngIf="!visibility.isSelected">check_box_outline_blank</i><i class="material-icons check-icon checked" *ngIf="visibility.isSelected">check_box</i></div>
                <div>{{visibility.label}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- type filter-->
      <div class="btn-area">
        <div class="button button-white dense-icon-btn">
          <div class="btn-inner dense-icon-btn filter-btn">
            <div *ngIf="!selectedIncidentType" (click)="isUnfoldIncidentTypeDropdown = true">
              <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Type Filter</span>
            </div>
            <ng-container *ngIf="selectedIncidentType"><i class="material-icons filter-icon">person</i><span class="exist-filter ellipsis" *ngIf="selectedIncidentType" style="max-width: 200px;" (click)="isUnfoldIncidentTypeDropdown = true">{{selectedIncidentType.name}}</span><i class="material-icons filter-icon" style="margin-left: 8px;" (click)="clearTypeFilter()">cancel</i></ng-container>
          </div>
        </div>
        <div class="filter-box" *ngIf="isUnfoldIncidentTypeDropdown">
          <div class="select-list" #typeSelect>
            <div class="search-result-input">
              <input class="list-search-input" autocomplete="off" type="text" #selectSearchInput placeholder="Search Type" [(ngModel)]="searchTypeTxt" (input)="searchType(searchTypeTxt)"/>
            </div>
            <div style="max-height: 200px;overflow-y: auto; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
              <div class="select-result has-child selectitem" *ngFor="let type of filteredTypeList" (click)="$event.stopPropagation();selectType(type)">
                <div class="ellipsis" [class.selected]="type?.id == selectedIncidentType?.id">{{type.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- category filter-->
      <div class="btn-area" *ngIf="selectedIncidentType">
        <div class="button button-white dense-icon-btn">
          <div class="btn-inner dense-icon-btn filter-btn">
            <div *ngIf="!selectedIncidentCategory" (click)="isUnfoldIncidentCategoryDropdown = true">
              <comp-icon class="filter-icon" [icon]="'filter_list'" [size]="16" [color]="'hsla(0,0%,0%,0.6)'"></comp-icon><span>Category Filter</span>
            </div>
            <ng-container *ngIf="selectedIncidentCategory"><i class="material-icons filter-icon">person</i><span class="exist-filter ellipsis" *ngIf="selectedIncidentCategory" style="max-width: 200px;" (click)="isUnfoldIncidentCategoryDropdown = true">{{selectedIncidentCategory?.name}}</span><i class="material-icons filter-icon" style="margin-left: 8px;" (click)="clearCategoryFilter()">cancel</i></ng-container>
          </div>
        </div>
        <div class="filter-box" *ngIf="isUnfoldIncidentCategoryDropdown">
          <div class="select-list" #categorySelect>
            <div class="search-result-input">
              <input class="list-search-input" autocomplete="off" type="text" #selectSearchInput placeholder="Search Category" [(ngModel)]="searchCategoryTxt" (input)="searchCategory(searchCategoryTxt)"/>
            </div>
            <div style="max-height: 200px;overflow-y: auto; border-bottom: 1px solid rgba(0, 0, 0, 0.1);">
              <div class="select-result has-child selectitem" *ngFor="let category of filteredCategoryList" (click)="$event.stopPropagation();selectCategory(category)">
                <div class="ellipsis" [class.selected]="category == selectedIncidentCategory?.name">{{category?.name}}</div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="table-area">
    <div class="content-body table-container">
      <table class="table-header" sortable-table="sortable-table" (sorted)="sortTableByColumn($event)">
        <colgroup>
          <col *ngFor="let col of tableHeader" [width]="col.width"/>
        </colgroup>
        <thead>
          <tr>
            <th *ngFor="let header of tableHeader" [sortable-column]="header.value">
               {{header.name}}
              <input *ngIf="header.isCheckbox" type="checkbox" [checked]="isAllSelected" (click)="toggleAllCheckbox($event)"/>
            </th>
          </tr>
        </thead>
      </table>
      <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-data'"> <i class="material-icons">inventory_2</i>
        <div>No Report List</div>
      </div>
      <div class="alternative-contents" *ngIf="determineElementToShow() === 'no-permission'"> <i class="material-icons">do_not_disturb_on</i>
        <div>Permission Denied</div>
      </div>
      <div class="table-body" *ngIf="determineElementToShow() === 'normal'">
        <table>
          <colgroup>
            <col *ngFor="let col of tableHeader" [width]="col.width"/>
          </colgroup>
          <tbody>
            <ng-container *ngIf="!isLoading">
              <tr class="has-child" *ngFor="let report of pagedItems" (click)="goToDetail($event, report)">
                <td> 
                  <div class="--g-tooltip-content v-center" (mouseenter)="setTooltipPosition($event)">
                    <div class="status-badge" [ngClass]="computedAccessBadgeStyleClass(report)"></div>
                    <div class="--g-tooltip tooltip-background" style="text-transform: none">{{ computedAccessBadgeTooltip(report) }}</div>
                  </div>
                </td>
                <td>{{report?.site_name}}</td>
                <td>{{report?.dealer_name}}</td>
                <td> 
                  <div style="font-size: 12px; color: #55647B">{{report?.created_date}}</div>
                </td>
                <td> 
                  <div style="font-size: 12px; color: #55647B">{{report?.created_by}}</div>
                </td>
                <td>{{report?.name}}</td>
                <td> 
                  <div class="type-badge" *ngIf="report?.type">{{ report?.type }}</div>
                </td>
                <td> 
                  <div class="type-badge" *ngIf="report?.category">{{ report?.category }}</div>
                </td>
                <td>
                  <div class="more-content" #actionMenus [id]="report?.id" (mouseenter)="setMorePosition(report)">
                    <div class="more-selector" (click)="$event.stopPropagation();toggleMenu(report)">
                      <comp-icon [icon]="'more_horiz'" [size]="20" [color]="'hsla(0, 0%, 0%, 0.87)'"></comp-icon>
                    </div>
                    <div class="more" [id]="'more-'+report?.id" [class.show]="report?.isShowMenu">
                      <div class="more-item row" (click)="goToDetail($event, report)">
                        <div class="div">View Detail</div>
                      </div>
                      <div class="more-item row" (click)="downloadPDF(report)">
                        <div class="div">Download PDF</div>
                      </div>
                      <div class="more-item row" *ngIf="hasSharedIncidentReportPermission" (click)="openShareDialog(report)">
                        <div class="div">Shared by Email</div>
                      </div>
                      <div class="more-item row" *ngIf="hasSharedIncidentReportPermission" (click)="openLogOfSharingDialog(report)">
                        <div class="div">View Email Sharing Records</div>
                      </div>
                      <div class="more-item row text-primary" *ngIf="hasUpdateIncidentReportVisiblityPermission" (click)="changeVisibilityInEndUserApp($event, report)">
                        <div class="div">{{report.is_visible_in_end_user_app ? 'Convert to Internal Report' : 'Publish to Customer'}} </div>
                      </div>
                      <div class="more-item row text-danger" *ngIf="hasDeleteIncidentReportPermission" (click)="openDeleteDialog($event, report)">
                        <div class="div">Delete</div>
                      </div>
                    </div>
                  </div>
                </td>
              </tr>
            </ng-container>
          </tbody>
        </table>
      </div>
      <!-- pagination-->
      <div class="pagination-area">
        <div style="font-size:12px;padding-right: 7px;"></div>
        <div class="space"></div>
        <div class="flex" style="font-size:12px;padding-right: 7px; gap: 2px">
          <div>{{pageOffsetStart}} - {{pageOffsetEnd}}</div>
          <div>of </div>
          <div>{{totalItem}}</div>
        </div>
        <div class="pagination">
          <div class="page-mover">
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0" (click)="setPage(pager.currentPage - 1)">
                <div class="btn-inner"><i class="material-icons" style="font-size: 16px" [class.disabled]="pager.currentPage === 1 || pager.currentPage === 0">arrow_back</i><span>Prev</span></div>
              </div>
            </div>
            <div class="btn-area">
              <div class="button button-white" [class.disabled]="pager.currentPage === pager.totalPages" (click)="setPage(pager.currentPage + 1)">
                <div class="btn-inner"><span>Next</span>
                  <comp-icon [icon]="'arrow_forward_n'" [color]="'#000'" [size]="16" [class.disabled]="pager.currentPage === pager.totalPages"></comp-icon>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-container>